// extracted by mini-css-extract-plugin
module.exports = {"cls1":"SideNav-TocLink-module--cls1--2TXMz","cls2":"SideNav-TocLink-module--cls2--3Ynil SideNav-TocLink-module--cls1--2TXMz","active":"SideNav-TocLink-module--active--RY6bM"};